export function createSerializedLatestQueue({ onError, onIdle, onSuccess, run }) {
  const pending = new Map()
  let running = false

  function drain() {
    if (running) return

    const nextEntry = pending.entries().next().value
    if (!nextEntry) {
      onIdle?.()
      return
    }

    const [key, value] = nextEntry
    pending.delete(key)
    running = true

    Promise.resolve()
      .then(() => run(value, key))
      .then((payload) => {
        onSuccess?.(payload, value, key)
      })
      .catch((error) => {
        onError?.(error, value, key)
      })
      .finally(() => {
        running = false
        drain()
      })
  }

  return {
    enqueue(key, value) {
      if (!key) return

      pending.set(key, value)
      drain()
    },
    isRunning() {
      return running
    },
    pendingCount() {
      return pending.size
    }
  }
}
